import { useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { Loader2, Send } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const initial = { name: "", organisation: "", email: "", phone: "" };

const fields = [
  { key: "name", label: "Name", type: "text", placeholder: "Your full name" },
  { key: "organisation", label: "Organisation", type: "text", placeholder: "Your organisation" },
  { key: "email", label: "Email", type: "email", placeholder: "you@organisation.org" },
  { key: "phone", label: "Phone", type: "tel", placeholder: "+91 98765 43210" },
];

export const ContactForm = ({ idPrefix = "contact", onSuccess }) => {
  const [form, setForm] = useState(initial);
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await axios.post(`${API}/leads`, form);
      toast.success("Thanks for reaching out! Our team will get back to you shortly.");
      setForm(initial);
      onSuccess?.();
    } catch {
      toast.error("Something went wrong. Please try again or write to partnerships@dhwaniris.com.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <form onSubmit={submit} className="space-y-4" data-testid={`${idPrefix}-form`}>
      {fields.map((f) => (
        <div key={f.key}>
          <label htmlFor={`${idPrefix}-${f.key}`} className="block text-sm font-semibold mb-1.5">{f.label}</label>
          <input
            id={`${idPrefix}-${f.key}`}
            data-testid={`${idPrefix}-${f.key}-input`}
            type={f.type}
            required
            placeholder={f.placeholder}
            value={form[f.key]}
            onChange={(e) => setForm({ ...form, [f.key]: e.target.value })}
            className="w-full px-4 py-2.5 rounded-[10px] border border-[#D8D8DE] bg-white text-[15px] placeholder:text-[#9498A3] focus:outline-none focus:ring-2 focus:ring-[#9E1B32]/30 focus:border-[#9E1B32] transition-colors"
          />
        </div>
      ))}
      <button
        type="submit"
        disabled={loading}
        data-testid={`${idPrefix}-submit-btn`}
        className="w-full inline-flex items-center justify-center gap-2 px-6 py-3 rounded-[10px] bg-[#9E1B32] text-white text-[15px] font-semibold shadow-[0_4px_12px_-2px_rgba(158,27,50,0.4)] hover:bg-[#7A1426] active:scale-[0.98] transition-[background-color,transform] disabled:opacity-60"
      >
        {loading ? <Loader2 size={17} className="animate-spin" /> : <Send size={16} />}
        {loading ? "Sending..." : "Send message"}
      </button>
    </form>
  );
};

export default ContactForm;
